import React, { useEffect } from 'react';
import './style.css'; 
import { formatMoney } from '../../../utils/formating'; // Assuming formatMoney is available

const CardProduct = ({ data, id, actions }) => {
    if (!data) {
        return null;
    } 
    return (
        <div className="card-product-container">
            <div className='title'>
                <span className="card-product-name">{data.name}</span>
                <p>{data.actions}</p> 
            </div>
            <div className='card-info-box'> 
                <span>
                    Unitario:
                    <p>{data.unitario}</p>
                </span>
                <span>
                    Cantidad:
                    <p>{data.cantidad}</p> 
                </span> 
            </div>
            <br></br>
            <span>{formatMoney(data.subtotal)}</span>
        </div>
    );
};

export default CardProduct;
